import PropTypes from 'prop-types';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box } from '@mui/material';
import React from 'react';


// ----------------------------------------------------------------------

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
};

export default function Iconify({ icon, sx, ...other }) {
    
  // If icon is a React SVG element, render it directly
  if (React.isValidElement(icon)) {
    return (
      <Box sx={{ ...sx }} {...other}>
        {icon}
      </Box>
    );
  }
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
